import SpeedManagePane from "./SpeedManagePane";
import SpeedManagePaneCustomizeItem from "./SpeedManagePaneCustomizeItem";

export default SpeedManagePane;
export { SpeedManagePane, SpeedManagePaneCustomizeItem };
